import { render, staticRenderFns } from "./email-from-to.vue?vue&type=template&id=69b1afd6"
import script from "./email-from-to.vue?vue&type=script&lang=ts"
export * from "./email-from-to.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports